<template>
  <div class="next-family-message">
    <el-breadcrumb separator="/" style="padding:12px 0;">
      <el-breadcrumb-item :to="{ path: `${messageData.type === '下家' ? '/nextFamily' : '/sellerList'}` }">
        {{ messageData.type === '下家' ? '下家单号列表' : '卖家单号列表'}}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/message' }">
        {{ messageData.type === '下家' ? '下家留言界面' : '卖家留言界面'}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="message-card">
      <div class="next-family-message-top">
        <el-table :data="tableData" border stripe style="width: 80%;">
          <el-table-column prop="firm_name" :label="messageData.type === '下家' ? '下家账号' : '客户账号'"></el-table-column>
          <el-table-column prop="order_number" width="170" label="转单号"></el-table-column>
          <el-table-column prop="channel_order_number" width="170" label="渠道转单号"> </el-table-column>
          <el-table-column :prop="messageData.type === '下家' ? 'status_text' : 'customer_order_number'" :label="messageData.type === '下家' ? '状态' : '订单号'"></el-table-column>
          <el-table-column prop="shop_name" width="100" label="店铺"> </el-table-column>
          <el-table-column prop="user_name" width="100" label="创建人"> </el-table-column>
          <el-table-column prop="create_time" width="180" label="创建时间"> </el-table-column>
        </el-table>
        <div class="next-family-message-submit-btn">
          <el-button type="danger" @click="handleSubmit" v-if="tableData[0].status !== 3">结单</el-button>
          <el-button type="primary" style="background:gray;" v-if="tableData[0].status === 3" disabled>已结单</el-button>
          <span>{{ tableData[0].finish_user_name }} {{ tableData[0].finish_time }}</span>
        </div>
      </div>
      <el-divider content-position="left" class="message-details-txt">留言详情</el-divider>
      <div class="message-details">
        <div v-for="(item, i) in message_list" :key="i" class="message-details-item">
          <div class="message" v-if="item.type == 1 || item.type == 2">
            <!-- <div>{{message_list.length==1||i==0?true:message_list[i].uid != message_list[i-1].uid}}</div>
            <div>
              {{message_list[i].uid}}
            </div>
            <div>
              {{message_list.length==1||i==0?true:message_list[i-1].uid}}
            </div> -->
            <div class="message-content">
              <div style="display: flex;flex-direction: column;margin-bottom: 5px;">
                <span class="time">{{ item.create_time }}</span>
                <div style="display: flex;">
                  <div>
                  <span class="name" style="margin-right:11px;font-weight:900;">{{ item.user_name }}</span>
                  </div>
                  <div class="message-body">
                    <span class="message-txt">{{ item.message }}</span>
                    <div class="message-img">
                      <el-image v-for="(img, index) in item.img_list" :preview-src-list="item.img_list" :src="img" :key="index" @click.stop="handleClickItem" style="width: 150px;height: 100px;margin-right:6px"></el-image>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <span v-if="message_list.length!=1?message_list[i].uid == message_list[i==0?i+1:i-1].uid:true" class="time">{{ item.create_time }}</span> -->
            </div>
          </div>
          <div class="system-message" v-else>
            {{ item.message }}，修改时间：{{ item.create_time }}
          </div>
          <div style="width:100%;display: flex;justify-content: center">
            <div v-if="i != message_list.length-1" style="width:100%;height: 2px;background: #CCCCD8;"></div>
          </div>
        </div>
      </div>
      <div class="reply-message-card">
        <div style="width: 800px;margin-right: 48px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
          <div class="reply-message">
            <div class="head">
              <div class="head-txt">
                <i class="head-txt-icon" />
                回复留言
              </div>
              <el-button class="submit" @click="handleSubmitMessage" v-if="tableData[0].status !== 3">提交留言</el-button>
            </div>
            <el-input type="textarea" :rows="6" v-model="messageValue" placeholder="请输入内容(必填)" resize="none"></el-input>
            <div class="footer">
              <div id="preview" v-on:paste="handlePaste" class="preview_img">
                <span>将图片按Ctrl+V 粘贴至此处</span>
              </div>
              <!-- <el-upload ref="upload" class="upload-demo" action="" :http-request="uploadImg" list-type="picture-card" multiple :limit="10">
                <i class="el-icon-plus"></i>
              </el-upload> -->
            </div>
          </div>
        </div>
        <div style="width: calc(100% - 800px);display: flex;flex-direction: column;justify-content: center;align-items: center;" v-if="userInfo.roles === 3">
          <div class="additional-fees">
            <div class="head">
              <div class="head-left">
                <div class="head-txt">
                  <i class="head-txt-icon" />
                  附加费用
                </div>
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                  <el-input placeholder="请输入内容" v-model="costData.cost">
                    <template slot="append">¥</template>
                  </el-input>
                  <span style="color: #FF5656;font-size: 12px;">* 当前附加费用：{{ costData.nowCost }} ¥</span>
                </div>
              </div>
              <el-button class="submit" @click="handleSubmitCost" v-if="tableData[0].status !== 3">提交费用</el-button>
            </div>
            <el-input type="textarea" :rows="12" v-model="costData.cost_message" placeholder="请输入内容(必填)" resize="none"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PostNextFailyOrderDetail, PostNextFailySendMessage, PostNextFailyEditCost, PostNextFailyFinishOrder } from '../../api/nextFamily'
import { PostSellerListOrderDetail, PostSellerListSendMessage, PostSellerListEditCost, PostSellerListFinishOrder } from '../../api/sellerList'
export default {
  data: () => ({
    costData: {
      cost: 0,
      nowCost: 0,
      cost_message: ''
    },
    messageValue: '',
    tableData: [{}],
    formData: new FormData(),
    userInfo: JSON.parse(localStorage.getItem('user_info')),
    messageData: JSON.parse(localStorage.getItem('messageData')),
    iconList: [require('../../assets/img/ask_yellow_icon.png'), require('../../assets/img/answer_blue_icon.png')],
    message_list: [],
    messageImgIndex: 0
  }),
  created () {
    this.init()
  },
  methods: {
    init () {
      let url = null
      const { type, order_id } = this.messageData
      const params = {
        order_id
      }
      if (type === '下家') {
        url = PostNextFailyOrderDetail
      } else {
        url = PostSellerListOrderDetail
      }
      this.formData = new FormData()
      url(params).then(res => {
        const { message_list, order_data } = res
        const { cost, cost_message } = order_data

        this.tableData = [order_data]
        // for (const i in message_list) {
        //   message_list[i].message = message_list[i].message.replace(/\n/g, '<br/>')
        // }

        this.message_list = message_list
        this.costData = {
          cost: cost,
          nowCost: cost,
          cost_message
        }
      })
    },
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    handleSubmitMessage () {
      let url = null
      const { type, order_id } = this.messageData
      this.formData.append(`order_id`, order_id)
      this.formData.append(`message`, this.messageValue)
      if (type === '下家') {
        url = PostNextFailySendMessage
      } else {
        url = PostSellerListSendMessage
      }
      url(this.formData).then(res => {
        if (res.msg === '留言成功') {
          Object.assign(this.$data, this.$options.data())
          this.init()
          this.$('#preview').innerHTML = '<span>将图片按Ctrl+V 粘贴至此处</span>'
          this.$message.success(res.msg)
          this.$refs.upload.clearFiles()
        }
      })
    },
    handleSubmitCost () {
      let url = null
      const { type, order_id } = this.messageData
      const { cost, cost_message } = this.costData
      const params = {
        order_id,
        cost,
        message: cost_message
      }
      if (type === '下家') {
        url = PostNextFailyEditCost
      } else {
        url = PostSellerListEditCost
      }
      url(params).then(res => {
        if (res.msg === '修改成功') {
          const { cost, cost_message } = res.data
          this.$message.success(res.msg)
          this.costData = {
            cost: 0,
            nowCost: cost,
            cost_message
          }
        }
      })
    },
    handleSubmit () {
      let url = null
      const { type, order_id } = this.messageData
      const params = {
        order_id
      }
      if (type === '下家') {
        url = PostNextFailyFinishOrder
      } else {
        url = PostSellerListFinishOrder
      }
      url(params).then(res => {
        if (res.msg === '结单成功') {
          this.$message.success(res.msg)
          if (type === '下家') {
            this.$router.push('/nextFamily')
          } else {
            this.$router.push('/sellerList')
          }
        }
      })
    },
    uploadImg (data) {
      this.formData.append(`message_img[${this.messageImgIndex}]`, data.file)
      this.messageImgIndex++
    },
    $ (e) {
      let eType = 'queryeAll'
      if (e.indexOf('#') === 0) {
        eType = 'getElementById'
        e = e.substr(1, e.length)
      }
      if (e.indexOf('.') === 0) {
        eType = 'getElementsByClassName'
        e = e.substr(1, e.length)
      }
      return document[eType](e)
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null

      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return false
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return false
      }
      console.log(file)
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader()
      reader.onload = event => {
        const preview = this.$('#preview')
        preview.innerHTML = `<img style="height:80px;width:160px;" src="${event.target.result}">`
        this.formData.append(`message_img[0]`, file)
      }
      reader.readAsDataURL(file)
      this.file = file
    }
  }
}
</script>

<style lang="less">
.preview_img {
  width: 160px;
  height: 80px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  background-color: #fff;
  color: #409eff;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 80px;
};
.next-family-message {
  width: 1318px;
  padding: 20px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
  overflow: hidden;
  margin: 0 auto;
  .upload-demo {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .message-card {
    width: 100%;
    margin: 0 auto;
    background: #ffffff;
    padding: 20px 14px;
    padding-bottom: 0;
    height: calc(100% - 40px);
    overflow-y: auto;
    overflow-x: hidden;
    .next-family-message-top {
      display: flex;
      justify-content: space-between;
      .next-family-message-submit-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 20px;
        .el-button {
          width: 160px;
          font-size: 20px;
          color: #fff;
          letter-spacing: 4px;
          background: #ff5454;
        }
      }
      .el-table {
        border-right: 1px solid transparent;
        .el-table__header-wrapper {
        }
        &::before {
          display: none;
        }
        &::after {
          display: none;
        }
        th, td {
          border: 2px solid #CCCCD8;
        }
        th {
          border-bottom: 0
        }
        th + th, td + td {
          border-left: 0;
        }
        .cell {
          font-size: 13px;
          padding: 5px;
          text-align: center;
        }
      }
    }
    .cell {
      color: #02044a;
    }
    th {
      background: #f0f1f4;
    }
    .el-divider--horizontal {
      height: 2px;
    }
    .message-details-txt .el-divider__text {
      font-size: 20px;
      font-weight: bold;
      color: #02044a;
    }
    .message-details {
      background: #eef1f7;
      // margin: 40px 90px;
      padding: 10px;

      .message-details-item {
        // margin-top: 10px;
        &:first-child {
          margin-top: 0;
        }
      }

      .message {
        display: flex;

        .message-content {
          display: flex;
          flex-direction: column;
          width: calc(100% - 5px);
          // margin-bottom: 30px;

          .name {
            font-size: 14px;
            color: #6e6f95;
          }

          .time {
            font-size: 13px;
            color: #a1a2b8;
          }
          .message-body {
            max-width: 1050px;
            word-wrap:break-word;
            word-break:break-all;
            // margin-top: 20px;
          }
          .message-txt {
            font-size: 14px;
            color: #36364a;
            white-space: pre-wrap;
            // margin-top: 20px;
          }

          .message-img {
            display: flex;
            // margin-top: 10px;
          }
        }
      }

      .system-message {
        font-size: 14px;
        width: 100%;
        background: #d9e5f6;
        display: flex;
        justify-content: left;
        align-items: left;
        margin: 0;
      }
    }
  }
  .reply-message-card {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 0 90px;
    margin-top: 13px;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 42px;
      border-bottom: 2px solid #618bb7;
      transform: translateX(-1px);

      .head-left {
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        & > span {
          font-size: 14px;
          color: #595959;
          margin-left: 20px;
        }
      }

      .el-input {
        width: 120px;
        height: 20px;
        border-radius: 6px;
        font-size: 12px;

        .el-input__inner{
          height: 20px;
        }
      }

      .head-txt {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 135px;
        height: 42px;
        background: #618bb7;
        font-size: 17px;
        color: #ffffff;
        margin-right: 20px;

        .head-txt-icon {
          width: 6px;
          height: 17px;
          background: #fff;
          border-radius: 2px;
          margin-right: 8px;
        }
      }
    }

    .submit {
      padding: 10px 14px;
      background: #00a4a4;
      border-color: #00a4a4;
      border-radius: 4px;
      color: #ffffff;
      margin-right: 11px;
    }

    .reply-message {
      width: 100%;
      border: 2px solid #618bb7;
      border-radius: 6px;

      .el-textarea {
        color: #02044A;
        font-size: 18px;
        border: none;
        // padding: 29px 75px 25px 25px;
        textarea {
          font-size: 14px;
          max-height: 114px !important;
          border: none;
        }
      }

      .footer {
        width: 100%;
        // height: 164px;
        min-height: 90px;
        padding: 0 17px;
        border-top: 2px solid #618bb7;
        background: #F7F8FB;
        display: flex;
        justify-content: start;
        align-items: center;

        .el-upload--picture-card {
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #dddfe3;
          border: none;
        }

        .el-upload-list__item {
          width: 60px;
          height: 60px;
        }
      }
    }

    .additional-fees {
      width: 100%;
      border: 2px solid #618bb7;
      border-radius: 6px;

      .el-textarea {
        color: #02044A;
        border: none;
        // padding: 29px 35px 25px 25px;
          font-size: 14px;
        textarea {
          font-size: 14px;
          max-height: 210px !important;
          border: none;
        }
      }
    }
  }
}
</style>
